module.exports = __webpack_public_path__ + "img/7605e89.jpg";